import { useState, useRef, lazy, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../Redux/Store/type";
import { Dialog, DialogContent, Tabs, Tab, Box } from "@material-ui/core";
import DownloadAndUpdateSheetModalContent from "./components/DownloadAndUpdateSheetModalContent";
import UploadGstSheetModal from "./components/UploadGstSheetModal";
import OneCircle from "../../../Assets/images/1-circle.svg";
import TwoCircle from "../../../Assets/images/2-circle.svg";
import { BULK_UPLOAD_API_STATUS, BULK_UPLOAD_STATUS_VIEW } from "../../../Constants/bulkUpload";
import { withStyles } from "@material-ui/styles";
import {
  bulkUploadBatch,
  getStoreItemsInExcel,
  downloadItemsExcelByStoreId,
  setGstBulkUploadDetails,
  fetchGSTBillingDetails,
} from "../../../Redux/Actions";
import { useStyles } from "../style";
import download from "downloadjs";
import { ToastNotifySuccess } from "../../Toast";
import moment from "moment";
import { GST_BILLING_CONSTANT } from "../../../Constants";

const CustomDialog = withStyles({
  root: {
    "& .MuiDialog-paperWidthSm": {
      maxWidth: 706,
      width: "100%",
      height: 418,
    },
    "& .MuiDialogContent-root": {
      padding: "0px",
      borderRadius: 12,
    },
    "& .MuiPaper-rounded": {
      borderRadius: 12,
    },
  },
})(Dialog);

const UploadHsnCatalogSheetModal = (props: any): JSX.Element => {
  let timer: any = "";
  const dispatch = useDispatch();
  const classes: any = useStyles();
  const { showGstBulkUpload, onClose, setShowGstBulkUpload } = props;
  const [status, setStatus] = useState<number>(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
  const [value, setValue] = useState(0);
  const [downloadStart, setDownloadStart] = useState(false);
  const [showItemsUploadingModal, setShowItemsUploadingModal] = useState(false);
  const { store } = useSelector((state: RootState) => ({
    store: state.storeReducer.store,
  }));
  const { gstUploadBatchId, gstBulkUploadStatusDetails } = useSelector((state: RootState) => ({
    gstUploadBatchId: state.bulkUploadReducer.gstUploadBatchId,
    gstBulkUploadStatusDetails: state.bulkUploadReducer.gstBulkUploadStatusDetails,
  }));

  useEffect(() => {
    if (!gstBulkUploadStatusDetails || gstBulkUploadStatusDetails?.status === BULK_UPLOAD_API_STATUS.PROCESSING) {
      setStatus(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
    } else if (gstBulkUploadStatusDetails?.status === BULK_UPLOAD_API_STATUS.PROCESSED) {
      if (gstBulkUploadStatusDetails?.failed_entries > 0) {
        setStatus(BULK_UPLOAD_STATUS_VIEW.FAILURE);
      } else if (gstBulkUploadStatusDetails?.successful_entries === gstBulkUploadStatusDetails?.total_entries) {
        setStatus(BULK_UPLOAD_STATUS_VIEW.SUCCESS);
      }
      !showGstBulkUpload && setShowGstBulkUpload && setShowGstBulkUpload();
    }
  }, [gstBulkUploadStatusDetails]);

  useEffect(() => {
    if (gstUploadBatchId?.id) {
      setStatus(BULK_UPLOAD_STATUS_VIEW.PROCESSING);
      setShowGstBulkUpload && setShowGstBulkUpload();
    }
  }, [gstUploadBatchId]);

  const handleChange = (e: any) => {
    const selectedType = e.target.innerText.toLowerCase();
    const newValue = selectedType === "download & update sheet" ? 0 : 1;
    setValue(newValue);
  };

  const onFileChange = (e: any) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const formData = new FormData();
      formData.append("batch_type", "2");
      formData.append("file", file);
      formData.append("store_id", store.store_id);
      const dataToPost = {
        data: formData,
        filename: file.name,
        type: GST_BILLING_CONSTANT,
        callback: (status: boolean) => {
          setShowItemsUploadingModal(status);
        },
      };
      dispatch(
        bulkUploadBatch(dataToPost, () => {
          dispatch(fetchGSTBillingDetails());
        }),
      );
    }
  };

  const handleDownloadFile = () => {
    if (!downloadStart) {
      const dataToPost = {
        queryParams: `store_id=${store?.store_id}&batch_type=1`,
        callback: (flag: string) => {
          if (flag) {
            setDownloadStart(true);
            setCountdown();
            setValue(1);
          }
        },
      };
      dispatch(getStoreItemsInExcel(dataToPost));
    }
  };

  const setCountdown = () => {
    clearInterval(timer);
    timer = setInterval(() => {
      const dataToPost = {
        queryParams: `store_id=${store?.store_id}&batch_type=1`,
        callback: (flag: any, url: string) => {
          if (flag && timer) {
            clearInterval(timer);
            setDownloadStart(false);
            if (url) {
              downloadFile(url);
            }
          } else if (!flag && timer) {
            clearInterval(timer);
            setDownloadStart(false);
          }
        },
      };
      dispatch(downloadItemsExcelByStoreId(dataToPost));
    }, 3000);
  };

  const downloadFile = (url: string) => {
    fetch(url)
      .then((res) => res.blob()) // Gets the response and returns it as a blob
      .then((blob) => {
        const filename = `catalog_${moment().format("DD-MM-YYYY")}.xlsx`;
        download(new Blob([blob]), filename);
        ToastNotifySuccess("File downloaded successfully");
      });
  };

  const handleClose = () => {
    setShowItemsUploadingModal(false);
    dispatch(setGstBulkUploadDetails(""));
    onClose();
  };

  const bulkUploadModal = () => {
    return (
      <CustomDialog onClose={handleClose} open={showGstBulkUpload} maxWidth="sm">
        <DialogContent>
          <div className="ds-mb40">
            <Box style={{ borderBottom: "1px solid #b7b7b7", height: 76, margin: "0px 22px" }}>
              <Tabs
                value={value}
                classes={{
                  indicator: classes.indicator,
                }}
                onChange={handleChange}
                aria-label="upload tabs "
              >
                <Tab
                  label={
                    <div className="flex items-center" style={{ width: 272 }}>
                      <img src={OneCircle} />
                      <p className="mv0 ds-ml12">Download & Update Sheet</p>
                    </div>
                  }
                  className={classes.hsnTab}
                />
                <Tab
                  label={
                    <div className="flex items-center" style={{ width: 212 }}>
                      <img src={TwoCircle} />
                      <p className="mv0 ds-ml12">Upload Sheet</p>
                    </div>
                  }
                  className={classes.hsnTab}
                />
              </Tabs>
            </Box>
            {!value ? 
              <DownloadAndUpdateSheetModalContent
                downloadStart={downloadStart}
                handleDownloadFile={handleDownloadFile}
              />
             : 
              <UploadGstSheetModal
                status={status}
                handleClose={handleClose}
                showItemsUploadingModal={showItemsUploadingModal}
                onFileChange={onFileChange}
              />
            }
          </div>
        </DialogContent>
      </CustomDialog>
    );
  };

  return <>{bulkUploadModal()}</>;
};

export default UploadHsnCatalogSheetModal;
